
export function isCommandCenterEnabled(): boolean {
  return true;
}

export function isCommandCenterShareEnabled(): boolean {
  return true;
}

export function isCommunicationCenterEnabled(): boolean {
  return true;
}

export function isSupportMode(): boolean {
  return new URLSearchParams(window.location.search).get('support') === 'true';
}

export function isPersonalLineRatingEnabled(): boolean {
  return true;
}

export function isCommercialLinesRatingEnabled(): boolean {
  return true;
}

export function isCarrierAccessEnabled(): boolean {
  return true;
}

export function isHRCenterEnabled(): boolean {
  return true;
}

/** Comma-separated agency ids allowed to see a feature, from a REACT_APP_* env var. "*" allows every agency. */
function isAgencyAllowed(envValue: string | undefined): boolean {
  const allowedAgencies = (envValue || '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);
  if (allowedAgencies.length === 0) return false;
  if (allowedAgencies.includes('*')) return true;
  const currentAgencyId = localStorage.getItem('NCAgencyId') || '';
  return allowedAgencies.includes(currentAgencyId);
}

/** Opportunity Tracker is limited to the agencies listed in REACT_APP_OPPORTUNITY_TRACKER_AGENCIES. */
export function isOpportunityTrackerEnabled(): boolean {
  return isAgencyAllowed(process.env.REACT_APP_OPPORTUNITY_TRACKER_AGENCIES);
}

/** Voice chat (/assistant) is limited to the agencies listed in REACT_APP_VOICE_CHAT_AGENCIES while it rolls out. */
export function isVoiceChatEnabled(): boolean {
  return isAgencyAllowed(process.env.REACT_APP_VOICE_CHAT_AGENCIES);
}

export function isMacWorkflowsEnabled(): boolean {
  return true;
}

/**
 * Review Queue: super users, plus any login email listed in REACT_APP_REVIEW_QUEUE_EMAILS.
 * Mirrors AMPApi's ReviewQueueEmails check, which also lets super users through.
 */
export function isReviewQueueEnabled(): boolean {
  if (localStorage.getItem('isSuperUser') === 'true') return true;
  const email = (localStorage.getItem('userEmail') || '').toLowerCase();
  return (process.env.REACT_APP_REVIEW_QUEUE_EMAILS || '')
    .split(',')
    .map(e => e.trim().toLowerCase())
    .includes(email);
}
